import React, { useRef } from 'react'
import Webcam from 'react-webcam'
import CustomVideoPlayer from 'components/customVideoPlayer'
import Header from 'components/headers/bulletins'
import { useFormContextData } from '../contexts'
import useVideoCapture from './hook/useVideoCapture'
import useSubmitAuthentication from './hook/useSubmitAuthentication'
import { useModal } from './hook/useModal'

const VideoCapture: React.FC = () => {
    const webcamRef = useRef<Webcam>(null)
    const { formData, setFormData, resetFormData } = useFormContextData()
    const {
        startRecording,
        stopRecording,
        randomPhrase,
        isRecording,
        videoSrc,
        timer,
    } = useVideoCapture(webcamRef, setFormData)
    const { handleFinalSubmit, isUploading } = useSubmitAuthentication({
        formData,
        resetFormData,
    })
    const { handlePreviewOpen, handlePreviewClose, showModal } = useModal()

    return (
        <>
            <Header title="فیلم" />
            <div className="flex flex-col items-center p-4 mt-3 bg-white">
                <h1 className="text-xl mb-4 font-bold">
                    لطفا متن زیر را بخوانید:
                </h1>
                <p className="mb-4">{randomPhrase}</p>
                <div className="flex justify-center items-center">
                    <Webcam
                        audio={true}
                        ref={webcamRef}
                        screenshotFormat="image/png"
                        width={350}
                        height={350}
                        videoConstraints={{
                            facingMode: 'user',
                        }}
                        className="rounded-lg shadow-lg"
                        muted={true}
                    />
                </div>
                {!isRecording ? (
                    <button
                        onClick={startRecording}
                        className="relative mt-16 px-4 py-2 bg-green-1 text-white rounded-full flex items-center justify-center size-12"
                    >
                        <span className="absolute -inset-2 rounded-full border-2 border-green-1 "></span>
                    </button>
                ) : (
                    <div className="flex flex-col items-center gap-3 mt-16">
                        <button
                            onClick={stopRecording}
                            className="relative px-4 py-2 bg-red-1 text-white rounded-full flex items-center justify-center size-12"
                        >
                            <span className="absolute -inset-2 rounded-full border-2 border-red-1"></span>
                        </button>
                        <h2 className="text-sm text-gray-4">
                            {timer} ثانیه باقی مانده
                        </h2>
                    </div>
                )}
                {videoSrc && (
                    <div className="mt-4 flex flex-col items-center">
                        <button
                            onClick={handlePreviewOpen}
                            className="mt-2 px-4 py-2 bg-blue-1 text-white rounded text-xs"
                        >
                            پیش نمایش ویدیو
                        </button>
                    </div>
                )}
                {showModal && (
                    <div className="fixed inset-0 flex items-center justify-center h-screen bg-black bg-opacity-50 z-50 m-0">
                        <div className="bg-white rounded-lg p-4 w-full mx-auto mt-16">
                            <h2 className="text-xl mb-2 text-center font-bold">
                                پیش نمایش ویدیو
                            </h2>
                            {videoSrc && (
                                <CustomVideoPlayer videoSrc={videoSrc} />
                            )}
                            <div className="mt-4 flex justify-around">
                                <button
                                    onClick={handlePreviewClose}
                                    className="px-4 py-2 bg-yellow-1 text-black text-xs rounded"
                                >
                                    ضبط مجدد
                                </button>
                                <button
                                    onClick={handleFinalSubmit}
                                    className={`px-4 py-2 bg-green-1 text-white text-xs rounded ${
                                        isUploading
                                            ? 'opacity-50 cursor-not-allowed'
                                            : ''
                                    }`}
                                    disabled={isUploading}
                                >
                                    {isUploading
                                        ? 'در حال ارسال...'
                                        : 'تایید و ارسال'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default VideoCapture
